import { render, staticRenderFns } from "./SearchClientModal.vue?vue&type=template&id=044ec50c&scoped=true"
import script from "./SearchClientModal.vue?vue&type=script&lang=js"
export * from "./SearchClientModal.vue?vue&type=script&lang=js"
import style0 from "./SearchClientModal.vue?vue&type=style&index=0&id=044ec50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044ec50c",
  null
  
)

export default component.exports